import React, { Fragment, useEffect } from 'react'
import Scrollable from '../Edit/Scrollable';
import * as helpCenterContent from "./Data"
import { VideoArticleLists } from './VideoArticleLists';
import { VideoArticleBlocks } from './VideoArticleBlocks';
import { VideoArticleDetail } from './VideoArticleDetail';
import { ContactUsOptions } from './ContactUsOptions';
import { useContext } from 'react';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { RatingDialog } from '../SurveyDialogs/RatingDialog';
import { SearchComponent } from './SearchComponent';
import { SearchResults } from './SearchResults';
import { BottomSection } from './BottomSection';
import { TopSection } from './TopSection';
import { SubmitIdeaDialog } from './HubspotForms/SubmitIdea';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../../Renderers/GlobalContext';

const HelpCenter = ({ helpCenterFor, user }) => {
    const { state, dispatch } = useContext(HelpCenterContext)
    const { organization } = useContext(GlobalContext).state

    React.useEffect(() => {
        const dataItem = helpCenterContent[helpCenterFor]
        dispatch({ type: "SET_USER", payload: user })
        dispatch({ type: "SET_DATAITEM", payload: dataItem })
        dispatch({ type: "SET_HELPCENTER_FOR", payload: helpCenterFor })

    }, []);

    const { t, i18n } = useTranslation([
        "common/help_center"
    ], {
        useSuspense: false
    })

    useEffect(() => {
        // i18n.changeLanguage(organization.platformLanguage)
    }, [])

    return (
        <Fragment>
            <button
                className="btn btn-secondary"
                onClick={() => dispatch({ type: "TOGGLE_HELPCENTER" })}
            >
                <i className="me-1 fas fa-question"></i>{t("help_center_button_label")}
            </button>
            {state.showRatingDialog && <RatingDialog user={user} onClose={() => dispatch({ type: "TOGGLE_RATING_DIALOG" })} />}
            {state.showSubmitIdeaDialog && <SubmitIdeaDialog />}
            {
                state.showHelpCenter &&
                <div className="helpcenter-popup shadow-lg">
                    <TopSection />
                    <SearchComponent />
                    {(state.showDetailComponent || state.showContactUsOptions) &&
                        <div className="mt-3 ps-2">
                            <button className="btn btn-secondary btn-sm" onClick={() => dispatch({ type: "BACK_TO_HOME" })}>
                                <i className="me-2 far fa-long-arrow-left"></i>Back
                            </button>
                        </div>
                    }
                    <div className="middle-section h-100">
                        <Scrollable>
                            {(!state.showDetailComponent && !state.showContactUsOptions) &&
                                <Fragment>
                                    <SearchResults />
                                    {state.searchKeyword === "" &&
                                        <Fragment>
                                            <VideoArticleLists heading={"Relevant Topics"} />
                                            <VideoArticleBlocks data={state.dataItem.Video} />
                                        </Fragment>
                                    }
                                    <VideoArticleLists heading={"Other helpful resources"} />
                                </Fragment>
                            }
                            <VideoArticleDetail />
                            <ContactUsOptions />
                        </Scrollable>
                    </div>
                    <BottomSection />
                </div>
            }
        </Fragment >
    )
}

export default HelpCenter
